// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError, AxiosResponse } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getOnlineCourseData } from '../../../apis/onlineCourse';
import { OnlineCourse } from '../../../types/Model';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
import { RootState } from '../../rootReducer';

const { getOnlineCourseDataActions } = actionCreatorsList;

const outputActions = {
  success: getOnlineCourseDataActions.success,
  failure: getOnlineCourseDataActions.failure
};

type RequestActionTypes = ActionType<typeof getOnlineCourseDataActions.request>;
type OutputActionTypes = ActionType<typeof outputActions>;

const getOnlineCourseDataEpic = (
  action$: Observable<RootAction>,
  _state$?: Observable<RootState>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getOnlineCourseDataActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const id = action.payload.id || 0;
      // send api promise
      return getOnlineCourseData(id)
        .then((response: AxiosResponse<OnlineCourse>) => {
          // handle success case here
          return outputActions.success({
            onlineCourseData: response.data
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return outputActions.failure({ error });
        });
    })
  );
};

export { getOnlineCourseDataEpic as default};
